module.exports = __webpack_public_path__ + "static/img/mapa.fde716b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/mapa.png
// module id = Nf/6
// module chunks = 1